// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_Mxe","cls2":"CreateSocialItem-cls2_cYD CreateSocialItem-cls1_Mxe"};